import React from "react";
import Modal from "react-modal";

const ConfirmRemoveExpenseModal = (props) => (
    <Modal
        isOpen = { props.visible }
        onRequestClose = { props.hideModal }
        contentLabel = "Expense to remove"
        closeTimeoutMS = { 200 }
        className = "modal"    
    >
        <div className="modal_header">
            <div className="modal_icon">
                <i class="fa fa-exclamation-circle fa-shake fa-2xl modal_icon_warning" aria-hidden="true"></i>
            </div>
            <h2 className="modal__title">Are you sure you wish to remove this expense?</h2>
            <p className="modal_text">This action can not be undone.</p>
        </div>

        <div>
            <button className="button confirm_yes" onClick = { props.deleteExpense }>Yes</button> 
            <span> </span>
            <button className="button button--secondary confirm_no" onClick= { props.hideModal }>Nevermind</button>
        </div>    
    </Modal>
)
export default ConfirmRemoveExpenseModal;


// WEBPACK FOOTER //
// ./src/components/ConfirmRemoveExpenseModal.js